// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1NVmR","content":"ManualTimeModal_content__2NAK9"};